import PharmacyVendorDetailPage from "@/pages/pharmacy/PharmacyVendorDetailPage";

export default function VendorDetailPage() {
  return <PharmacyVendorDetailPage basePath="/pharmacist" />;
}
